const getters = {
  preview: (state) => state.preview,
  lastSelectedEntityTypes: (state) => state.lastSelectedEntityTypes,
  loading: (state) => state.loading,
  error: (state) => state.error,
  bitrixAuth: (state) => state.bitrixAuth,
  isBitrix: (state) => state.isBitrix,
  isBitrixLinked: (state) => state.isBitrixLinked,
  isBitrixConnectionValid: (state) => state.isBitrixConnectionValid,
};

export default getters;
